import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-business-info-popup',
  templateUrl: './business-info-popup.component.html',
  styleUrls: ['./business-info-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Business Info Popup
 */
export class BusinessInfoPopupComponent implements OnInit {
  @Input() activePoints?: number;
  @Input() pointsAddedThisMonth?: number;
  @Input() pointsExpiringThisMonth?: number;
  @Input() nextPointsExpiring?: number;
  @Input() nextPointsExpiringDate?: string;
  @Input() pointsExpiredLastYear?: number;
  @Input() pointsExpiringThisYear?: number;
  @Input() pointsExpiringNextYear?: number;
  @Input() pointsRedeemedThisMonth?: number;
  @Input() registersOnVIPWindow?: number;
  @Input() familyName?: string;
  @Input() state?: string;
  @Input() country?: string;
  @Output() closeClick = new EventEmitter();

  language = '';

  /**
   * @constructor
   */
  constructor(private readonly translationService: TranslationService) {}

  /**
   * on init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
  }

  /**
   * Triggers close click event
   * @param {MouseEvent} event
   */
  emitCloseClick(event: MouseEvent) {
    this.closeClick.emit(event);
  }

  /**
   * If this business info has no locale information
   */
  get noLocale() {
    return this.state == null && this.country == null;
  }

  /**
   * Returns the current year
   * @return {any} the current year
   */
  getThisYear(): any {
    return new Date().getFullYear();
  }

  /**
   * Return if any family name was inputed
   * @return {boolean}
   */
  hasFamily(): boolean {
    return this.familyName !== undefined;
  }
}
